import produce from 'immer';

const INITIAL_STATE = {
  opened: false,
};

export default function dialog(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@dialog/OPEN': {
        draft.opened = true;
        break;
      }

      // Adicionar case
      case '@alteracaoCentroCusto/SUCCESS_REMOVE':
      case '@operacaodreno/SUCCESS_REMOVE':
      case '@excecaoMeta/SUCCESS_REMOVE':
      case '@recalculaTurno/SUCCESS_REMOVE':
      case '@recebimentoAreiaNf/SUCCESS_REMOVE':
      case '@transferenciaAreiaSilo/SUCCESS_REMOVE':
      case '@afericaoAreiaSilo/SUCCESS_REMOVE':
      case '@tiposDeEquipamentosVeiculo/SUCCESS_REMOVE':
      case '@corredor/SUCCESS_IN_REQUEST':
      case '@retransregisintegracao/SUCCESS_REMOVE':
      case '@raizenerrologintegracao/SUCCESS_REMOVE':
      case '@raizenerrologintegracaoentradacomboio/SUCCESS_REMOVE':
      case '@raizenerrologintegracaomovimentacaocomboio/SUCCESS_REMOVE':
      case '@raizenerrologintegracaomovimentacaoposto/SUCCESS_REMOVE':
      case '@raizenerrologintegracaotransferencia/SUCCESS_REMOVE':
      case '@checkxmlnfrecebimentonf/SUCCESS_REMOVE':
      case '@preset/SUCCESS_REMOVE':
      case '@pitStopRegra/SUCCESS_REMOVE':
      case '@pitStopJustificativa/SUCCESS_REMOVE':
      case '@checkliberadoparaintegracao/SUCCESS_REMOVE':
      case '@transportadora/SUCCESS_REMOVE':
      case '@distribuidora/SUCCESS_REMOVE':
      case '@fechamentolmc/SUCCESS_REMOVE':
      case '@notafiscalrecebida/SUCCESS_REMOVE':
      case '@inversorFrequencia/SUCCESS_REMOVE':
      case '@linhaAbastecimento/SUCCESS_REMOVE':
      case '@mensagemSistemaoEquipamentoKm/SUCCESS_REMOVE':
      case '@mensagemSistemaOperacaoAgricola/SUCCESS_REMOVE':
      case '@mensagemSistemaMotorista/SUCCESS_REMOVE':
      case '@mensagemSistemaFrentista/SUCCESS_REMOVE':
      case '@mensagemSistemaEquipamentoPosto/SUCCESS_REMOVE':
      case '@mensagemSistemaEquipamento/SUCCESS_REMOVE':
      case '@mensagemsistemaposto/SUCCESS_REMOVE':
      case '@perfilFrentista/SUCCESS_REMOVE':
      case '@uploadplanilhacliente/SUCCESS_REMOVE':
      case '@clienteConfig/SUCCESS_REMOVE':
      case '@modulosCliente/SUCCESS_REMOVE':
      case '@pitStop/SUCCESS_REMOVE':
      case '@empresacliente/SUCCESS_REMOVE':
      case '@clienteConfig/SUCCESS_REMOVE':
      case '@modulosCliente/SUCCESS_REMOVE':
      case '@operacaomedicaotemperatura/SUCCESS_REMOVE':
      case '@operacaobatelada/SUCCESS_REMOVE':
      case '@cle/SUCCESS_REMOVE':
      case '@afericaoDvec/SUCCESS_REMOVE':
      case '@manutencaoDvec/SUCCESS_REMOVE':
      case '@edicaoAlinhamentoTanque/SUCCESS_REMOVE':
      case '@edicaoTrocaTanque/SUCCESS_REMOVE':
      case '@recebimento/SUCCESS_REMOVE':
      case '@turno/SUCCESS_REMOVE':
      case '@justificativaContingencia/SUCCESS_REMOVE':
      case '@justificativaalteracaoencerrantes/SUCCESS_REMOVE':
      case '@estoqueGeralModulosProdutos/SUCCESS_REMOVE':
      case '@operacaoBateriaDbic/SUCCESS_REMOVE':
      case '@auditoriaSistemas/SUCCESS_REMOVE':
      case '@operacaoLimpezaDvec/SUCCESS_REMOVE':
      case '@justificativaTrocaModoOperacional/SUCCESS_REMOVE':
      case '@alarmeSistema/SUCCESS_REMOVE':
      case '@precoproduto/SUCCESS_REMOVE':
      case '@operacaotransferencia/SUCCESS_REMOVE':
      case '@operacaoLubrificacao/SUCCESS_REMOVE':
      case '@perfis/SUCCESS_REMOVE':
      case '@gerencias/SUCCESS_REMOVE':
      case '@causasManutencoes/SUCCESS_REMOVE':
      case '@safras/SUCCESS_REMOVE':
      case '@arqueacoes/SUCCESS_REMOVE':
      case '@bico/SUCCESS_REMOVE':
      case '@conversorEntradaSaida/SUCCESS_REMOVE':
      case '@centrocusto/SUCCESS_REMOVE':
      case '@comboio/SUCCESS_REMOVE':
      case '@configuracaoalarmetanque/SUCCESS_REMOVE':
      case '@contrato/SUCCESS_REMOVE':
      case '@empresasveiculo/SUCCESS_REMOVE':
      case '@marcasveiculo/SUCCESS_REMOVE':
      case '@medidor/SUCCESS_REMOVE':
      case '@modelosveiculo/SUCCESS_REMOVE':
      case '@motorista/SUCCESS_REMOVE':
      case '@operacao/SUCCESS_REMOVE':
      case '@operacaoabastecimento/SUCCESS_REMOVE':
      case '@operacaoestoqueposto/SUCCESS_REMOVE':
      case '@operacaoestoquetanque/SUCCESS_REMOVE':
      case '@operacaorecebimento/SUCCESS_REMOVE':
      case '@posto/SUCCESS_REMOVE':
      case '@produto/SUCCESS_REMOVE':
      case '@tanquesfisicos/SUCCESS_REMOVE':
      case '@tanquesvirtual/SUCCESS_REMOVE':
      case '@terminal/SUCCESS_REMOVE':
      case '@tipoAreia/SUCCESS_REMOVE':
      case '@estoqueAreia/SUCCESS_REMOVE':
      case '@usuario/SUCCESS_REMOVE':
      case '@veiculo/SUCCESS_REMOVE':
      case '@locomotiva/SUCCESS_REMOVE':
      case '@estoqueproduto/SUCCESS_REMOVE':
      case '@operacaoLimpezaTag/SUCCESS_REMOVE':
      case '@operacaoTotalizadorVeiculo/SUCCESS_REMOVE':
      case '@logsdescarregamentos/SUCCESS_REMOVE':
      case '@auth/SIGN_OUT':
      case '@dialog/CLOSE': {
        draft.opened = false;
        break;
      }

      default:
    }
  });
}
